import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DowngradeAccountDialog from '../../../components/account/detail-card/downgrade-account-dialog'
// Actions
import { getRegisteredDomains, downgradeAccount, loadAccountById } from '../../../store/actions'

const mapStateToProps = state => {
  return {
    account: state.crm.getAccountByIdResponse,
    registeredDomainsRetrieving: state.crm.getRegisteredDomainsRetrieving,
    registeredDomains: state.crm.getRegisteredDomainsResponse,
    downgradeError: state.crm.downgradeAccountError,
    downgradePending: state.crm.downgradeAccountRetrieving,
    downgradeSuccessLogs: state.crm.downgradeAccountResponse
  }
}

const mapDispatch = dispatch => {
  return {
    getRegisteredDomains: bindActionCreators(getRegisteredDomains, dispatch),
    downgradeAccount: bindActionCreators(downgradeAccount, dispatch),
    loadAccountById: bindActionCreators(loadAccountById, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(DowngradeAccountDialog)
